import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { WebflowEndPage } from './webflow-end.page';

const routes: Routes = [
  {
    path: '',
    component: WebflowEndPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebflowEndPageRoutingModule {}
